import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../Text';
import Styles from './StepperStep.styles';

const Container = styled.div`${Styles.container}`;
const Circle = styled.div`${Styles.circle}`;
const StepNumber = styled(Text)`${Styles.stepNumber}`;
const Label = styled(Text)`${Styles.label}`;

/**
 * StepperStep component
 * @property {Object} props - component props
 * @returns {JSX.Element}
 */
const  StepperStep = ({ label, stepNumber, selected, showLabels, onClick, selectorItem, enabled}) => (
  <Container >
    <Circle onClick={onClick && enabled ? onClick : undefined} selectorItem={selectorItem} style={{ backgroundColor: selected ? '#EF60A3' : '#9078B5', cursor: enabled ? 'pointer' : 'auto' }}>
      <StepNumber>{stepNumber}</StepNumber>
    </Circle>
    {selected && showLabels && <Label style={{ color: selected ? '#EF60A3' : '#3F2A55' }}>{label}</Label>}
  </Container>
);

StepperStep.propTypes = {
  label: PropTypes.string,
  stepNumber: PropTypes.number,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  enable: PropTypes.bool
};
export default StepperStep;
